import {makeChatUrl} from '@frontend/helpers'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'
import {create} from 'zustand/react'
import {useUiLayoutStore} from './useUiLayoutStore'

// Тип состояния хранилища.
export interface MiniChatStoreType {
    // Данные:

    // Видимость мини-чата.
    visible: boolean

    // Мини-чат открыт или свернут?
    expanded: boolean

    // ID открытого пользователем чата.
    activeChatId: number | null

    // API:

    // Задать видимость мини-чата.
    setVisibility: (visible: boolean, expanded?: boolean) => void

    // Задать уровень отображения окна мини-чата (true: развернуто, false: свернуто).
    setExpanded: (expanded: boolean) => void

    // Задать способ отображение мини-чата (открыт или свернут).
    toggleExpanded: () => void

    // Задать ID открытого чата.
    // Только для использования в компоненте MiniChat!
    setActiveChatId(chatId: number | null): void

    // Открыть чат по ID извне компонента MiniChat.
    openChat: (chatId: number) => void
}

// Хранилище состояния мини-чата.
export const useMiniChatStore = create<MiniChatStoreType>(
    set => ({
        visible: true,
        expanded: false,
        activeChatId: null,

        // API:

        setVisibility(visible: boolean, expanded?: boolean): void {
            set({
                visible,
            })
            if (expanded !== undefined) {
                set({
                    expanded,
                })
            }
        },

        setExpanded(expanded: boolean): void {
            set({
                expanded,
            })
        },

        toggleExpanded(): void {
            set(state => ({
                expanded: !state.expanded,
            }))
        },

        setActiveChatId(chatId: number | null): void {
            set({
                activeChatId: chatId,
            })
        },

        openChat(chatId: number) {
            if (useUiLayoutStore.getState().deviceType === 'mobile') {
                return NavigationService.navigate(makeChatUrl(chatId))
            }
            set({
                activeChatId: chatId,
                expanded: true,
            })
        },
    })
)
